import React from "react";
import CTAButton from "./CTAButton";

function CTAButtonText(params) {
    return (
        <span>
            <CTAButton context={params?.context} category={params?.category} />
            <p className="sub"><b>Disclaimer:</b> Content subject to licensed territories.</p>
        </span>
    );
}

export default CTAButtonText;